import PendoButton from '../button/pendo-button.vue.js';

var script = {
  name: 'PendoDrawerClose',
  components: {
    PendoButton
  },
  inject: ['$drawer'],
  inheritAttrs: false
};

export { script as default };
//# sourceMappingURL=pendo-drawer-close.vue2.js.map
